import React from "react";

import {isEmpty} from "@pg-mono/nodash";

import {ResultsInfo} from "../../search/components/atoms/ResultsInfo";
import {RegionTabs} from "../../search/components/RegionTabs";
import {IDropdownListOwnProps, ResultWrapper} from "../../search/components/search_autocomplete/SearchAutocompleteDropdown";
import {RegionsTab, RegionsTabLabelTypes} from "../../search/components/search_autocomplete/tab_renderers/RegionsTab";
import {VendorsTab} from "../../search/components/search_autocomplete/tab_renderers/VendorsTab";
import {SuggestedRegions} from "../../search/components/SuggestedRegions";
import {SearchTab} from "../../search/types/SearchTab";

export const SearchVendorAutocompleteDropdown = (props: IDropdownListOwnProps) => {
    const renderActiveTabResults = () => {
        const {selectedTab} = props;
        switch (selectedTab) {
            case SearchTab.Regions:
                return (
                    <RegionsTab
                        regionsLabelType={RegionsTabLabelTypes.VENDORS}
                        regions={props.regions}
                        requestStateObj={props.requestStateObj}
                        activeItem={props.activeItem}
                        onLinkClick={props.onLinkClick}
                    />
                );
            case SearchTab.Vendors:
                return (
                    <VendorsTab
                        onLinkClick={props.onLinkClick}
                        activeItem={props.activeItem}
                        fetchPlacesRequest={props.requestStateObj.fetchPlacesRequest}
                        fetchVendorsRequest={props.requestStateObj.fetchVendorsRequest}
                        vendors={props.vendors}
                    />
                );
            default:
                return null;
        }
    };

    const renderDropdownContent = () => {
        if (props.search.label && isEmpty(props.search.label) && isEmpty(props.vendors)) {
            return <ResultsInfo title="Niestety nic nie znaleźliśmy" text="Zmień parametry wyszukiwania" />;
        } else if (!props.search.label) {
            return <SuggestedRegions activeItemId={props.activeItem.id} onLinkClick={props.onLinkClick} />;
        } else {
            return <ResultWrapper>{renderActiveTabResults()}</ResultWrapper>;
        }
    };

    return (
        <>
            <RegionTabs search={props.search} selectedTab={props.selectedTab} removeRegionTag={props.removeRegionTag} regionsLimit={VENDOR_REGIONS_LIMIT} />
            {renderDropdownContent()}
        </>
    );
};

const VENDOR_REGIONS_LIMIT = 3;
import React from "react";

import {isEmpty} from "@pg-mono/nodash";

import {ResultsInfo} from "../../search/components/atoms/ResultsInfo";
import {RegionTabs} from "../../search/components/RegionTabs";
import {IDropdownListOwnProps, ResultWrapper} from "../../search/components/search_autocomplete/SearchAutocompleteDropdown";
import {RegionsTab, RegionsTabLabelTypes} from "../../search/components/search_autocomplete/tab_renderers/RegionsTab";
import {VendorsTab} from "../../search/components/search_autocomplete/tab_renderers/VendorsTab";
import {SuggestedRegions} from "../../search/components/SuggestedRegions";
import {SearchTab} from "../../search/types/SearchTab";

export const SearchVendorAutocompleteDropdown = (props: IDropdownListOwnProps) => {
    const renderActiveTabResults = () => {
        const {selectedTab} = props;
        switch (selectedTab) {
            case SearchTab.Regions:
                return (
                    <RegionsTab
                        regionsLabelType={RegionsTabLabelTypes.VENDORS}
                        regions={props.regions}
                        requestStateObj={props.requestStateObj}
                        activeItem={props.activeItem}
                        onLinkClick={props.onLinkClick}
                    />
                );
            case SearchTab.Vendors:
                return (
                    <VendorsTab
                        onLinkClick={props.onLinkClick}
                        activeItem={props.activeItem}
                        fetchPlacesRequest={props.requestStateObj.fetchPlacesRequest}
                        fetchVendorsRequest={props.requestStateObj.fetchVendorsRequest}
                        vendors={props.vendors}
                    />
                );
            default:
                return null;
        }
    };

    const renderDropdownContent = () => {
        if (props.search.label && isEmpty(props.search.label) && isEmpty(props.vendors)) {
            return <ResultsInfo title="Niestety nic nie znaleźliśmy" text="Zmień parametry wyszukiwania" />;
        } else if (!props.search.label) {
            return <SuggestedRegions activeItemId={props.activeItem.id} onLinkClick={props.onLinkClick} />;
        } else {
            return <ResultWrapper>{renderActiveTabResults()}</ResultWrapper>;
        }
    };

    return (
        <>
            <RegionTabs search={props.search} selectedTab={props.selectedTab} removeRegionTag={props.removeRegionTag} regionsLimit={VENDOR_REGIONS_LIMIT} />
            {renderDropdownContent()}
        </>
    );
};

const VENDOR_REGIONS_LIMIT = 3;
